import { useEffect, useState } from "react";
import propertyGroupService from "../../../services/propertyGroupService/PropertyGroupService";
import { IPropertyGroup } from "../../../models/propertyGroup";
import DataTable, { IColumn } from "../../../components/table/data/DataTable";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Toolbar from "../../../components/toolbar/Toolbar";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { routes } from "../../../routes";

const usePropertyColumns = () => {
    const { t } = useTranslation();

    const columns: IColumn<IPropertyGroup>[] = [
        { field: "name", headerName: t("table.property.propertyGroup") },
        {
            field: "buildings",
            headerName: t("table.building.buildings"),
            transform: {
                render: (data: IPropertyGroup) => (
                    <Typography>
                        {data.buildings?.map((b) => b.name).join(", ")}
                    </Typography>
                ),
                filterTransform: (data: IPropertyGroup) => {
                    return data.buildings?.map((b) => b.name).join(", ")
                },
            },
        },
        {
            field: "codes", headerName: "codes",
            transform: {
                render: (data: IPropertyGroup) => (
                    <Typography>
                        {data.codes?.join(", ")}
                    </Typography>
                ),
                filterTransform: (data: IPropertyGroup) => {
                    return data.codes?.join(", ")
                },
            },
        },
        {
            field: "punchDeviceId",
            headerName: t("table.property.punchDeviceId"),
            transform: {
                render: (data) => (
                    <Typography variant="body2">
                        {data.punchDeviceId || "X"}
                    </Typography>
                ),
                filterTransform: (data) => {
                    return data.punchDeviceId || "X";
                },
            },
        },


    ];
    return columns;
};

const PropertyGroupPage = () => {
    const [propertyGroups, setPropertyGroups] = useState<IPropertyGroup[]>([]);
    const columns = usePropertyColumns();
    const navigate = useNavigate();
    const [isFilterActive, setIsFilterActive] = useState<boolean>(true);

    useEffect(() => {
        propertyGroupService.GetPropertyGroups().then((propertyGroups) => {
            setPropertyGroups(propertyGroups)
        })
    }, []);

    return (
        <Box sx={{ width: "100%", height: "100%" }}>
            <Toolbar
                onFilterClick={() => setIsFilterActive((old) => !old)}
                onCreate={() => navigate(routes.tableRoute.propertyGroupAdd)}
                isFilterActive={isFilterActive}
            />
            <DataTable
                dense
                rows={propertyGroups}
                columns={columns}
                onRowClick={(row) =>
                    navigate("edit", { state: { ...row } })
                }
                getRowNavTo={(row) => "edit"}

            />
        </Box>
    );
};

export default PropertyGroupPage;
